import React, { memo, useCallback, useMemo} from "react";
import { Card, Controller, Button, SelectBox } from "components/src";
import { useTranslation } from "react-i18next";
import { FormProvider, useForm } from "react-hook-form";
import { Form } from "antd";
import {
  useGetAdminGetAllChannelsList,
  useGetAdminUsersList,
  useGetAuthorityAccessList,
  // useGetAuthorityAuthorityList,
  useGetAuthorityFindRoles,
  usePutAuthorityUpdateAccess,
} from "core";
import LoadingView from "../../../atoms/loadingView";
import { useParams } from "react-router-dom";

const FIRSTENTITY = "firstEntity";
const SECONDENTITY = "secondEntity";
const FIRSTUSER = "user1";
const SECONDUSER = "user2";
const FIRSTROLE = "role1";
const SECOANDROLE = "role2";
const AUTHORITIES="authorities"


const layout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 16 },
};

const EditOprationalAccess = memo(() => {
  const { id } = useParams();
  
  const { i18n } = useTranslation();
  const { data: usersData} = useGetAdminUsersList({
    pageNumber: "1",
    pageSize: "2000",
  });
  const { data: rolesData} = useGetAuthorityFindRoles({pageNumber:'1',pageSize:'2000'});
  const { data: channelsData} = useGetAdminGetAllChannelsList({pageNumber:'1',pageSize:'2000'});
  const methods = useForm({
    defaultValues: {
      firstEntity: "",
      secondEntity: "",
      user1: "",
      role1: "",
      user2: "",
      role2: "",
      authorities: [],
    },
  });
  
  const { handleSubmit, reset, watch } = methods;
  const _firstEntity = watch("firstEntity");
  const _secondEntity = watch("secondEntity");
  const { mutate, isPending } = usePutAuthorityUpdateAccess({
    onSuccess: () => {
      reset();
    },
  });

  const onSubmit = useCallback(
    ({
      user1,
      role1,
      user2,
      role2,
      authorities,
    }: {
      user1: string;
      role1: string;
      user2: string;
      role2: string;
      authorities: any;
    }) => {
      mutate({
        requestBody: {
          accessId: id || "",
          user1,
          role1,
          user2,
          role2,
          authorities,
        },
      });
    },
    []
  );

  const usersItem = useMemo((): any[] => {
    return usersData?.data?.users.map((item: any) => {
      return {
        value: item.userName,
        label: item?.nameAndFamily,
      };
    });
  }, [usersData]);

  const rolesItem = useMemo((): any[] => {
    return rolesData?.data?.roles?.map((item: any) => {
      return {
        value: item.name,
        label: item?.name,
      };
    });
  }, [rolesData]);

  const channelsItem = useMemo((): any[] => {
    return channelsData?.data?.conversations?.map((item: any) => {
      return {
        value: item.id,
        label: item?.title,
      };
    });
  }, [channelsData]);



  const firstEntityItem = [
    { label: i18n.t("user"), value: "user" },
    // { label: i18n.t("role"), value: "role" },
  ]?.map((item) => {
    return {
      value: item.value,
      label: item.label,
    };
  });

  const secoandEntityItem = [
    { label: i18n.t("user"), value: "user" },
    // { label: i18n.t("role"), value: "role" },
  ]?.map((item) => {
    return {
      value: item.value,
      label: item.label,
    };
  });



  // const AuthotitiesItem =authoritiesData?.data?.map((item:any)=>{
  //   return{
  //   value: item.name,
  //   label: item.name    
  // }
  // })

  return (
    <>
    {/* <LoadingView isLoading={authoritiesFetch}> */}
      <Card title={i18n.t("createOperationalAccess")}>
        <FormProvider {...methods}>
          <Form
            {...layout}
            name="nest-messages"
            onFinish={handleSubmit(onSubmit)}
          >
            <Form.Item>
             <Controller rules={{ required: i18n.t('isRequired') }} name={FIRSTENTITY}>
                <SelectBox
                  placeholder={i18n.t("firstEntity")}
                  label={i18n.t("firstEntity")}
                  options={firstEntityItem}
                />
              </Controller>
            </Form.Item>

            {_firstEntity === "user" && (
              <Form.Item>
                <Controller rules={{ required: i18n.t('isRequired') }} name={FIRSTUSER}>
                  <SelectBox
                    // disabled={!Boolean(firstEntity)}
                    placeholder={i18n.t("firstUser")}
                    label={i18n.t("firstUser")}
                    options={usersItem}
                  />
                </Controller>
              </Form.Item>
            )}

            {_firstEntity === "role" && (
              <Form.Item>
                <Controller rules={{ required: i18n.t('isRequired') }} name={FIRSTROLE}>
                  <SelectBox
                    placeholder={i18n.t("firstRole")}
                    label={i18n.t("firstRole")}
                    options={rolesItem}
                  />
                </Controller>
              </Form.Item>
            )}

            <Form.Item>
              <Controller rules={{ required: i18n.t('isRequired') }} name={SECONDENTITY}>
                <SelectBox
                  placeholder={i18n.t("SecondEntity")}
                  label={i18n.t("secondEntity")}
                  options={secoandEntityItem}
                />
              </Controller>
            </Form.Item>

            {_secondEntity=== "user" &&
              <Form.Item>
                <Controller rules={{ required: i18n.t('isRequired') }} name={SECONDUSER}>
                  <SelectBox
                    placeholder={i18n.t("secondUser")}
                    label={i18n.t("secondUser")}
                    options={usersItem}
                  />
                </Controller>
              </Form.Item>
            }
            {_secondEntity === "role" &&
            <Form.Item>
              <Controller rules={{ required: i18n.t('isRequired') }} name={SECOANDROLE}>
                <SelectBox
                  placeholder={i18n.t("secondRole")}
                  label={i18n.t("secondRole")}
                  options={rolesItem}
                />
              </Controller>
            </Form.Item>}
            {_secondEntity === "channel" &&
            <Form.Item>
              <Controller rules={{ required: i18n.t('isRequired') }} name={SECOANDROLE}>
                <SelectBox
                  placeholder={i18n.t("secondRole")}
                  label={i18n.t("secondRole")}
                  options={channelsItem}
                />
              </Controller>
            </Form.Item>}
          
            {/* <Form.Item>
              <Controller name={AUTHORITIES}>
                <SelectBox
                mode="tags"
                placeholder={i18n.t("access")}
                label={i18n.t("access")}
                options={AuthotitiesItem}
                />
              </Controller>
            </Form.Item> */}

            <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 5 }}>
              <Button
                style={{ width: "100px" }}
                type="primary"
                isLoading={isPending}
                htmlType="submit"
              >
                {i18n.t("done")}
              </Button>
            </Form.Item>
          </Form>
        </FormProvider>
      </Card>
      {/* </LoadingView> */}
    </>
  );
});
export { EditOprationalAccess };
